import React, { useState, useContext } from 'react';
import { SimpleStorageContext } from '../../context/simpleStorage/simpleStorageContext';
import Swal from 'sweetalert2';

const extractYouTubeVideoId = (url) => {
    const patterns = [
        /(?:youtube\.com\/watch\?v=)([^&]+)/,
        /(?:youtu\.be\/)([^?]+)/,
        /(?:youtube\.com\/embed\/)([^?]+)/
    ];

    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) {
            return match[1];
        }
    }

    return null;
};

const getYouTubeThumbnail = (url) => {
    const videoId = extractYouTubeVideoId(url);
    if (!videoId) return '';

    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
};

function GalleryItem({ item, type, idCasa, onDeleteComplete, entityCode }) {
    const [isHovering, setIsHovering] = useState(false);

    const { deleteImage, deleteVideo, fetchImages, fetchVideos } = useContext(SimpleStorageContext);

    const handleDelete = async () => {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `Se eliminará ${type === 'images' ? 'la imagen' : 'el video'} permanentemente`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                if (type === 'images') {
                    await deleteImage(item.app_simple_storage_object_id, item.app_simple_storage_object_filename);
                    await fetchImages(idCasa, entityCode);
                } else {
                    await deleteVideo(item.app_simple_storage_object_id);
                    await fetchVideos(idCasa, entityCode);
                }
                Swal.fire('Eliminado', 'El elemento ha sido eliminado', 'success');
                if (onDeleteComplete) {
                    onDeleteComplete();
                }
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el elemento', 'error');
            }
        }
    };

    const handleVideoClick = () => {
        if (type === 'videos') {
            window.open(item.url, '_blank');
        }
    };

    return (
        <div
            className='position-relative'
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <div className='w-100 h-100'>
                {type === 'images' ? (
                    <img
                        src={item.app_simple_storage_object_url}
                        alt={item.app_simple_storage_object_filename}
                        className='w-100 h-100 rounded'
                        style={{ objectFit: 'cover' }}
                    />
                ) : (
                    <div
                        className='w-100 h-100 rounded'
                        style={{
                            backgroundImage: `url(${getYouTubeThumbnail(item.app_simple_storage_object_url)})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            cursor: 'pointer'
                        }}
                        onClick={handleVideoClick}
                    >
                        <div className='d-flex align-items-center justify-content-center h-100'>
                            <div className='bg-dark rounded-circle p-3' style={{ opacity: 0.8 }}>
                                <i className='fas fa-play text-white' style={{ fontSize: '24px' }}></i>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {isHovering && (
                <div
                    className='w-100 h-100 rounded d-flex align-items-center justify-content-center'
                    style={{ opacity: 0.7, transition: 'opacity 0.2s' }}
                >
                    <button
                        className='btn btn-danger btn-sm'
                        onClick={handleDelete}
                    >
                        <i className='fas fa-trash'></i> Eliminar
                    </button>
                </div>
            )}
        </div>
    );
}

export default GalleryItem;
